const genererFigures = (fxhash) => {
  let alphabet = "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ";
  let b58dec = (str) =>
    [...str].reduce(
      (p, c) => (p * alphabet.length + alphabet.indexOf(c)) | 0,
      0
    );
  let fxhashTrunc = fxhash.slice(2);
  let regex = new RegExp(".{" + ((fxhash.length / 4) | 0) + "}", "g");
  let hashes = fxhashTrunc.match(regex).map((h) => b58dec(h));
  let sfc32 = (a, b, c, d) => {
    return () => {
      a |= 0;
      b |= 0;
      c |= 0;
      d |= 0;
      var t = (((a + b) | 0) + d) | 0;
      d = (d + 1) | 0;
      a = b ^ (b >>> 9);
      b = (c + (c << 3)) | 0;
      c = (c << 21) | (c >>> 11);
      c = (c + t) | 0;
      return (t >>> 0) / 4294967296;
    };
  };
  var fxrand = sfc32(...hashes);

  const figures = [];
  const features = {};
  function pickWord(arr) {
    var index = parseInt(fxrand() * arr.length);

    var item = arr[index].toUpperCase();

    arr.splice(index, 1);

    return item;
    //picks.push(item);
  }

  // naming
  var adj = ["sharp"];

  var cell = ["blade"];

  var qualadj = ["indomptable"];

  var qualnoun = ["courage"];

  features.type = pickWord(adj) + " " + pickWord(cell);

  features.qualifier = pickWord(qualadj) + " " + pickWord(qualnoun);

  features.Name = features.type + " OF " + features.qualifier;

  // handle

  const points = [{ x: 0, y: 0 }];

  let startY = 0;
  for (let i = 0; i < fxrand() * 5 + 4; i++) {
    points.push({ x: fxrand() * 3 + 1, y: startY });
    startY += fxrand() * 2 + 1;
  }
  points.push({ x: 2, y: startY });
  points.push({ x: 0, y: startY });

  figures.push({
    geometry: {
      type: "LatheGeometry", // Type of geometry
      args: [points],
    },
    pos: {
      // Position
      x: 0,
      y: -40,
      z: 0,
    },
    rot: {
      // Rotation
      x: 0,
      y: Math.PI,
      z: 0,
    },
    lines: true, // Display Segments
    hatch: true, // Fill with white texture
    full: false, // Fill with color texture (in the anaverse, red and cyan)
  });

  // blade
  const shapeArgsBlade = [];
  const pBlade = [[0, 0]];

  //shape.moveTo( 0,0 );
  shapeArgsBlade.push({ draw: "moveTo", drawArgs: [0, 0] });

  for (let i = 0; i < 20; i++) {
    pBlade[i + 1] = [(fxrand() - 0.5) * (20 - i)/2, pBlade[i][1] + 0.2 + fxrand() * 5];
    // shape.lineTo( p[i+1][0], p[i+1][1] );
    shapeArgsBlade.push({
      draw: "lineTo",
      drawArgs: [pBlade[i + 1][0], pBlade[i + 1][1]],
    });
  }

  let next = fxrand();
  if(next < 0.3) {
    next = (i) => {
      return (22-i)/2;
    }
  } else if(next > 0.3 && next <= 0.6) {
    next = (i) => {
      return 5;
    }
  } else {
    next = (i) => {
      return fxrand() * 10;
    }
  }
  console.log(next)
  for (let i = 19; i >= 0; i--) {
    //shape.lineTo( p[i][0] + fxrand() * 10, p[i][1] );
    shapeArgsBlade.push({
      draw: "lineTo",
      drawArgs: [pBlade[i][0] + next(i), pBlade[i][1]],
    });
  }

  //shape.lineTo( 0, 0 );
  shapeArgsBlade.push({ draw: "lineTo", drawArgs: [0, 0] });
  let distance = fxrand() * 3 + 1;

  const bladeExtrudeSettings = {
    steps: 1,
    depth: 0,
    bevelEnabled: true,
    bevelThickness: 0.8,
    bevelSize: distance,
    bevelOffset: -1,
    bevelSegments: 1,
  };

  figures.push({
    geometry: {
      type: "ExtrudeGeometry", // Type of geometry
      shapeArgs: shapeArgsBlade,
      extrudeSettings: bladeExtrudeSettings,
    },
    pos: {
      // Position
      x: 6,
      y: -startY,
      z: 0.02,
    },
    rot: {
      // Rotation
      x: 0,
      y: 0,
      z: 0,
    },
    lines: false, // Display Segments
    hatch: false, // Fill with white texture
    full: true, // Fill with color texture (in the anaverse, red and cyan)
  });

  //symmetry
  figures.push({
    geometry: {
      type: "ExtrudeGeometry", // Type of geometry
      shapeArgs: shapeArgsBlade,
      extrudeSettings: bladeExtrudeSettings,
    },
    pos: {
      // Position
      x: -6,
      y: -startY,
      z: 0,
    },
    rot: {
      // Rotation
      x: 0,
      y: Math.PI,
      z: 0,
    },
    lines: true, // Display Segments
    hatch: true, // Fill with white texture
    full: false, // Fill with color texture (in the anaverse, red and cyan)
  });


  features.fpLoc = {
    rot: {
      x: 0,
      y: -Math.PI * 0.45,
      z: 0,
    },
    pos: {
      x: 2,
      y: 0,
      z: -7,
    },
  };

  // console.log(figures);

  return { figures, features };
};

export { genererFigures };